<template>
  <iframe v-if="url" :src="url" width="100%" height="100vh"> </iframe>
  <div v-else style="background: white; padding: 20px">
    <p>Generating...</p>
    <p>This usually takes about a 8 minutes.</p>
  </div>
</template>

<script>
import Echo from "laravel-echo";
import request from "@/services/request";
import Pusher from "pusher-js";
import itinerary from "@/services/itinerary";

const echo = new Echo({
  broadcaster: "pusher",
  key: process.env.VUE_APP_PUSHER_KEY,
  authEndpoint: `${request.defaults.baseURL}/tenant/broadcasting/auth`,
  cluster: process.env.VUE_APP_PUSHER_CLUSTER,
  forceTLS: true,
  Pusher: Pusher,
});

const channel = `travel-program`;

export default {
  name: "TravelProgram",
  data() {
    return {
      showNewSalesManualModal: false,
      showCongratulationsMessage: false,
      url: null,
    };
  },
  mounted() {
    const number = this.$route.params.id;
    if (this.$route.query.g) {
      this.$router.replace({
        path: this.$route.path,
      });
      itinerary.generateTravelProgram(number);
      echo
        .channel(`travel-program.${number}`)
        .listen(".travel-program.generated", ({ url }) => {
          this.url = url;
        });
    } else {
      this.url = `${process.env.VUE_APP_AWS_CDN_URL}/tenancy/tenantela/travel-programs/${number}.pdf`;
    }
  },
  beforeDestroy() {
    echo.leave(channel);
  },
};
</script>

<style>
body,
body div,
body div iframe {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  margin: 0;
  background-color: rgb(40, 40, 40);
}

html {
  overflow-y: hidden;
}
</style>
